<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col lg:flex-row lg:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
        Parking Dashboard · บัญชี
        <span class="text-sm font-black text-amber-600 bg-amber-50 dark:bg-amber-900/30 px-2.5 py-1 rounded-lg">Phase 1</span>
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        สรุปรายได้ + กราฟรายวันต่อลานจอด — รู้วันไหนรายได้สูงสุด
      </p>
    </div>

    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 no-print">
      <div *ngIf="lastFetchedTime"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" [disabled]="!canSearch || isLoading()" title="รีเฟรช"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center cursor-pointer disabled:opacity-40">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 space-y-4">
      <div class="flex flex-wrap items-center gap-2">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">dashboard</span>
          เงื่อนไข
        </h3>
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
        <span *ngIf="result()?.flags?.ev"
          class="text-[11px] font-bold text-teal-700 dark:text-teal-300 bg-teal-50 dark:bg-teal-900/30 px-2 py-0.5 rounded-lg">EV</span>
        <span *ngIf="result()?.flags?.monthly"
          class="text-[11px] font-bold text-orange-700 dark:text-orange-300 bg-orange-50 dark:bg-orange-900/30 px-2 py-0.5 rounded-lg">Monthly</span>
      </div>

      <div *ngIf="!selectedSiteId"
        class="rounded-2xl border border-amber-200 dark:border-amber-800 bg-amber-50/80 dark:bg-amber-900/20 px-4 py-3 text-sm font-medium text-amber-800 dark:text-amber-300">
        กรุณาเลือกลานจาก Navbar ก่อน — Dashboard ดูได้ทีละลานเท่านั้น
      </div>

      <div class="flex flex-wrap gap-2">
        <button type="button" (click)="onPeriodModeChange('month')"
          class="px-4 py-2 rounded-xl text-xs font-bold border transition-all cursor-pointer"
          [ngClass]="periodMode === 'month'
            ? 'bg-amber-400 border-amber-400 text-slate-900'
            : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-500'">
          รายเดือน
        </button>
        <button type="button" (click)="onPeriodModeChange('range')"
          class="px-4 py-2 rounded-xl text-xs font-bold border transition-all cursor-pointer"
          [ngClass]="periodMode === 'range'
            ? 'bg-amber-400 border-amber-400 text-slate-900'
            : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-500'">
          กำหนดช่วงวัน
        </button>
      </div>

      <div class="flex flex-col lg:flex-row lg:items-end gap-3 max-w-4xl">
        <div *ngIf="periodMode === 'month'" class="w-full md:w-[220px]">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">เดือน</label>
          <input type="month" [(ngModel)]="monthValue" (ngModelChange)="onMonthChange()"
            class="w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 px-3 font-bold text-sm text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 [color-scheme:light] dark:[color-scheme:dark]">
        </div>

        <div *ngIf="periodMode === 'range'" class="grid grid-cols-1 md:grid-cols-2 gap-3 flex-1">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จากวันที่</label>
            <div
              class="relative w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden">
              <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
                <span class="material-icons text-slate-400 text-lg">calendar_today</span>
              </div>
              <input #startDatePicker type="date" [(ngModel)]="startDate" (ngModelChange)="onRangeChange()"
                [max]="endDate || undefined" (click)="startDatePicker.showPicker()"
                class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ถึงวันที่</label>
            <div
              class="relative w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden">
              <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
                <span class="material-icons text-slate-400 text-lg">calendar_today</span>
              </div>
              <input #endDatePicker type="date" [(ngModel)]="endDate" (ngModelChange)="onRangeChange()"
                [min]="startDate || undefined" [max]="maxEndDate" (click)="endDatePicker.showPicker()"
                class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
            </div>
          </div>
        </div>

        <button type="button" (click)="onSearch()" [disabled]="!canSearch || isLoading()"
          class="h-[46px] px-6 shrink-0 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-xl shadow-sm transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
          <span class="material-icons text-[20px]">search</span>
          {{ isLoading() ? 'กำลังโหลด...' : 'ดูสรุป' }}
        </button>
      </div>

      <p class="text-[11px] text-slate-400 font-medium">
        ช่วงที่เลือก: {{ periodLabel }} · สูงสุด 2 เดือน · ชุดการ์ดเป็นค่าเริ่มต้น (Admin ตั้งค่าทีหลัง)
      </p>
    </div>

    <div class="relative p-4 md:p-6 min-h-[280px]">
      <div *ngIf="!isLoading() && !hasSearched()" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block opacity-40">insights</span>
        <p class="font-bold">เลือกลานและช่วงเวลา แล้วกดดูสรุป</p>
      </div>

      <div *ngIf="!isLoading() && hasSearched() && cards().length === 0" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block opacity-40">inbox</span>
        <p class="font-bold">ไม่พบการ์ดสรุปสำหรับลานนี้</p>
      </div>

      <div *ngIf="cards().length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        <div *ngFor="let stat of cards(); let i = index"
          class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
          [ngStyle]="{'animation-delay': (i * 0.04) + 's'}">
          <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-10 transition-transform group-hover:scale-110"
            [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>
          <div class="relative z-10 flex justify-between items-start mb-4">
            <div class="w-12 h-12 rounded-xl flex items-center justify-center shadow-sm"
              [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
              <span class="material-icons text-2xl">{{ stat.icon }}</span>
            </div>
          </div>
          <div class="relative z-10">
            <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1 truncate">{{ stat.title }}</h4>
            <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight tabular-nums">
              {{ stat.value }}
              <span *ngIf="stat.hint === 'บาท'" class="text-sm font-bold text-slate-400 ml-1">บาท</span>
            </div>
            <p *ngIf="stat.hint && stat.hint !== 'บาท'" class="text-[11px] text-slate-400 mt-1 font-medium">{{ stat.hint }}</p>
          </div>
        </div>
      </div>

      <div *ngIf="(result()?.revenueByType?.length ?? 0) > 0" class="mt-6 rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden">
        <div class="px-4 py-2.5 bg-slate-50 dark:bg-slate-900/60 border-b border-slate-100 dark:border-slate-700 font-bold text-slate-700 dark:text-slate-200">
          รายได้แยกตามประเภทค่าบริการ
        </div>
        <div class="overflow-x-auto">
          <table class="w-full text-left border-collapse min-w-[520px] text-xs">
            <thead>
              <tr class="text-[10px] font-bold text-slate-400 uppercase tracking-wider text-center">
                <th class="p-2 border border-slate-100 dark:border-slate-700">รหัส</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">ประเภท</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">จำนวนใบ</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">ยอดเงิน (บาท)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of result()!.revenueByType" class="tabular-nums hover:bg-slate-50/60 dark:hover:bg-slate-700/40">
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-center font-mono">{{ t.typeFeeId }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700">{{ t.typeFeeName }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-right">{{ t.count | number }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-right font-bold">{{ t.amount | number:'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div *ngIf="hasChartData" class="mt-8 space-y-6">
        <div *ngIf="result()?.peaks as peaks"
          class="grid grid-cols-1 md:grid-cols-1 gap-3 max-w-md">
          <div class="peak-chip peak-chip--amber">
            <p class="peak-chip__label">วันรายได้สูงสุด</p>
            <p class="peak-chip__value">
              {{ formatDate(peaks.peakRevenueDate) }}
              <span>{{ formatMoney(peaks.peakRevenueAmount) }} บาท</span>
            </p>
          </div>
        </div>

        <div class="flex flex-col gap-6">
          <!-- Revenue chart -->
          <div class="chart-card">
            <div class="chart-card__head">
              <div>
                <h3 class="chart-card__title">รายได้รวมรายวัน</h3>
                <p class="chart-card__sub">บาท · รวมทุกประเภทค่าบริการ</p>
              </div>
              <div class="chart-toggle">
                <button type="button" (click)="revenueChartType = 'bar'"
                  [class.active]="revenueChartType === 'bar'">
                  <span class="material-icons text-sm">bar_chart</span>
                </button>
                <button type="button" (click)="revenueChartType = 'line'"
                  [class.active]="revenueChartType === 'line'">
                  <span class="material-icons text-sm">show_chart</span>
                </button>
              </div>
            </div>

            <div class="chart-legend">
              <span class="chart-legend__item"><i class="dot dot--amber"></i>รายได้</span>
            </div>

            <div *ngIf="revenueChartType === 'bar'" class="bar-chart" (mouseleave)="hoveredRevenue.set(null)">
              <div class="bar-chart__grid">
                <span *ngFor="let y of revenueYLabels.slice().reverse()">{{ y | number:'1.0-0' }}</span>
              </div>
              <div class="bar-chart__plot">
                <div class="bar-chart__guides">
                  <span></span><span></span><span></span><span></span>
                </div>
                <div class="bar-chart__cols">
                  <div *ngFor="let b of revenueBars; let i = index"
                    class="bar-col bar-col--single"
                    (mouseenter)="hoveredRevenue.set(i)">
                    <div class="bar-col__stack">
                      <div class="bar bar--amber"
                        [class.bar--peak]="b.isPeak"
                        [style.height.%]="b.pct"
                        [style.animation-delay]="(i * 18) + 'ms'"></div>
                    </div>
                    <span class="bar-col__label" [class.bar-col__label--dense]="revenueBars.length > 16">{{ b.label }}</span>
                  </div>
                </div>
                <div *ngIf="hoveredRevenue() !== null" class="chart-tooltip"
                  [style.left.%]="((hoveredRevenue()! + 0.5) / revenueBars.length) * 100">
                  <p class="chart-tooltip__date">{{ revenueBars[hoveredRevenue()!].fullDate }}</p>
                  <p><span class="text-amber-500">รายได้</span> {{ revenueBars[hoveredRevenue()!].value | number:'1.2-2' }} บาท</p>
                </div>
              </div>
            </div>

            <div *ngIf="revenueChartType === 'line'" class="line-chart">
              <svg viewBox="0 0 640 240" class="line-chart__svg" preserveAspectRatio="xMidYMid meet">
                <defs>
                  <linearGradient id="finRevFill" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stop-color="#f59e0b" stop-opacity="0.32" />
                    <stop offset="100%" stop-color="#f59e0b" stop-opacity="0" />
                  </linearGradient>
                  <filter id="finRevGlow" x="-20%" y="-20%" width="140%" height="140%">
                    <feGaussianBlur stdDeviation="2.5" result="blur" />
                    <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
                  </filter>
                </defs>
                <g class="line-chart__guides" stroke="currentColor">
                  <line x1="28" y1="20" x2="624" y2="20" /><line x1="28" y1="68" x2="624" y2="68" />
                  <line x1="28" y1="116" x2="624" y2="116" /><line x1="28" y1="164" x2="624" y2="164" />
                  <line x1="28" y1="212" x2="624" y2="212" />
                </g>
                <polygon [attr.points]="revenueAreaPoints" fill="url(#finRevFill)" />
                <polyline [attr.points]="revenueLinePoints" fill="none" stroke="#f59e0b" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" filter="url(#finRevGlow)" />
                <circle *ngFor="let p of revenueDots" [attr.cx]="p.x" [attr.cy]="p.y" [attr.r]="p.isPeak ? 6 : 3.8"
                  fill="#fff" stroke="#f59e0b" [attr.stroke-width]="p.isPeak ? 3 : 2">
                  <title>{{ p.label }}: {{ p.value | number:'1.2-2' }} บาท</title>
                </circle>
              </svg>
              <div class="line-chart__ylabels">
                <span *ngFor="let y of revenueYLabels.slice().reverse()">{{ y | number:'1.0-0' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
